import React from 'react';
import SectionDivider from '../SectionDivider';
import ProductCard from '../../mweb/ProductCard/ProductCard';
import Icon from '../../mweb/Icon/Icon';
import {
  addItem,
  getProducts,
  removeItem,
} from 'hb-redux-store/feature/subscription/subscription.action';
import { connect } from 'react-redux';
import Empty from '../Empty/Empty';

const ALL_KEY = 'All';
class SubscriptionItems extends React.Component {
  constructor(props) {
    super(props);
    const openItems = {};
    if (props.subscriptionItems?.map) {
      props.subscriptionItems.map(({ section }) => (openItems[section] = true));
    }
    this.state = {
      selectedSection: ALL_KEY,
      openItems,
    };
  }

  render() {
    const { subscriptionItems, selectedDay, addItem, removeItem } = this.props;
    const { selectedSection, openItems } = this.state;
    const sections = subscriptionItems;
    let pills = [ALL_KEY];
    if (subscriptionItems?.length) {
      pills = [ALL_KEY, ...subscriptionItems?.map(p => p.section)];
    }
    const isLoggedInUser = this.props.launchInfo.loggedIn;
    return (
      <React.Fragment>
        {selectedDay && subscriptionItems && (
          <div className="subsc--pane">
            <div className="subsc--pane--title">Select Items</div>
            <div className="subsc--pane--content">
              {pills.length > 0 && (
                <div className="subsc--section-pills">
                  {pills.map(p => (
                    <div
                      className={`subsc--section-pills--pill pill ${
                        p === selectedSection ? 'selected' : ''
                      }`}
                      key={p}
                      onClick={() => {
                        const state = {
                          selectedSection: p,
                          openItems: { ...this.state.openItems },
                        };
                        sections.map(({ section }) => {
                          state.openItems[section] =
                            p === ALL_KEY || p === section;
                        });
                        this.setState(state);
                      }}
                    >
                      {p}
                    </div>
                  ))}
                </div>
              )}
              <div className="subsc--categories">
                {sections.map(p => {
                  return (
                    <React.Fragment key={p.section + p.changeCounter}>
                      <div className="subsc--categories--title">
                        <div
                          className="justify-content--space-between"
                          onClick={() => {
                            const openItems = { ...this.state.openItems };
                            openItems[p.section] = !this.state.openItems[
                              p.section
                            ];
                            this.setState({ openItems });
                          }}
                        >
                          <div>{p.section}</div>
                          <Icon
                            class={
                              openItems[p.section]
                                ? 'icon-common-black-arrow-right arrow-up'
                                : 'icon-common-black-arrow-right arrow-down'
                            }
                            size={12}
                          />
                        </div>
                      </div>
                      {!!openItems[p.section] &&
                        p.products.map(product => (
                          <div
                            className="subsc--categories--item"
                            key={`${p.section}-${product.productId}`}
                          >
                            <ProductCard
                              product={product}
                              onIncrement={data => {
                                if (!isLoggedInUser) {
                                  return data.failOpCb({
                                    errorMessage: 'Please login to subscribe.',
                                  });
                                }
                                addItem({
                                  ...data,
                                  ...selectedDay,
                                  selectedDate: selectedDay.date,
                                });
                              }}
                              onDecrement={data => {
                                removeItem({ ...data, ...selectedDay });
                              }}
                              source="Subscription"
                            />
                          </div>
                        ))}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        {(!selectedDay || !subscriptionItems) && (
          <div>
            <Empty
              title="No Day Selected!"
              iconSize={100}
              message="Please choose week and day to see products"
            />
          </div>
        )}
        <SectionDivider />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = ({ subscriptionReducer, initialReducer }) => ({
  subscriptionId: subscriptionReducer.subscriptionId,
  subscriptionItems: subscriptionReducer.subscriptionItems,
  selectedDay: subscriptionReducer.selectedDay,
  loading: subscriptionReducer.loading,
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  getProducts,
  addItem,
  removeItem,
};

export default connect(mapStatetoProps, mapDispatchToProps)(SubscriptionItems);
